import React, { useState, useEffect, useContext } from "react";
import Modal from "@mui/material/Modal";
import { useSearchParams } from "react-router-dom";
import { UserContext } from "./UserContext";
import { CircularProgress } from "@mui/material";
import { Autocomplete } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Switch from '@mui/material/Switch';
import States from "./States.json";
import './AddOfficeLocationPopUpUI.css'


const AddOfficeLocationPopUpUI = (props) => {
  const [searchParams] = useSearchParams();
  const [id, setId] = useState("");
  const [openOLPopUp, setOpenOLPopUp] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [active, setActive] = useState(true);
  const [state, setState] = useState("Karnataka");
  const [city, setCity] = useState("Bangalore");
  const [area, setArea] = useState("");
  const [company, setCompany] = useState("");
  const [office, setOffice] = useState("");
  const [longitude, setLongitude] = useState("");
  const [latitude, setLatitude] = useState("");
  const [locations, setLocations] = useState([]);
  const [mapUrl,setMapUrl] = useState("");
  const [documentUrl,setDocumentUrl] = useState("");
  const [clawPeriod,setClawPeriod] = useState(0);
  const [img,setImg] = useState("");
  const [profilePic,setProfilePic]= useState("");
  const [aldocument,setALdocument] = useState("");
  const [alDName,setAlDName] = useState("");
  const { user } = useContext(UserContext);

useEffect(()=>{
if(user){
    if(props.open){
        setOpenOLPopUp(props.open)
        if(props.selectedRowData){
           
            setId(props.selectedRowData.id);
    setActive(props.selectedRowData.active);
    setState(props.selectedRowData.state);
    setCity(props.selectedRowData.city);
    // setArea(row.area);
    setCompany(props.selectedRowData.company);
    setOffice(props.selectedRowData.office);
    setLongitude(props.selectedRowData.longitude);
    setLatitude(props.selectedRowData.latitude);
    setMapUrl(props.selectedRowData.mapUrl);
    if(props.selectedRowData.officeLogoUrl && props.selectedRowData.officeLogoUrl.length>50){
      setImg("https://drive.google.com/uc?export=view&id="+props.selectedRowData.officeLogoUrl.split('/')[5])
      // console.log("https://drive.google.com/uc?export=view&id="+repos.data.profilePicUrl.split('/')[5])
                    }
                    setDocumentUrl(props.selectedRowData.authorizationLetterUrl)
        }
    }
}

},[props.open])


const handleClose = () =>{
   
    resetApplicant();
    setOpenOLPopUp(false);
    props.close();
    
}

const resetApplicant = () => {
    setId("");
    setImg("");
    setState("");
    setCity("");
    
    setCompany("");
    setOffice("");
    setLongitude("");
    setLatitude("");
    setClawPeriod(0);
    setMapUrl("");
  };


const handleImageUpload = async (e) => {
    if (e.target.files[0].size > 71680) {
      //alert("Please choose a file with size below 70kb!");
      props.showAlert("Please choose a file with size below 70kb!","error")
      return;
    }
    handleFileSelect(e.target.files[0]);

    setProfilePic(e.target.files[0]);
   
  };
  function handleFileSelect(f) {
    var reader = new FileReader();
    // Closure to capture the file information.
    reader.onload = (function (theFile) {
      return function (e) {
        var binaryData = e.target.result;
        //Converting Binary Data to base 64
        var base64String = window.btoa(binaryData);
        //showing file converted to base64
        setImg("data:image/jpeg;base64," + base64String);
      };
    })(f);
    // Read in the image file as a data URL.
    reader.readAsBinaryString(f);
  }

    //Upload Image
    const UploadImageToDrive = async (officeLocationId,value,document) =>{
     
        var file = document //the file
        var reader = new FileReader() //this for convert to Base64 
        reader.readAsDataURL(document) //start conversion...
        reader.onload = function (e) { //.. once finished..
          var rawLog = reader.result.split(',')[1]; //extract only thee file data part
          var dataSend = { dataReq: { data: rawLog, name:file.name, type: file.type }, fname: "uploadFilesToGoogleDrive" }; //preapre info to send to API
         fetch(process.env.REACT_APP_GOOGLEDRIVE_URL, //your AppsScript URL
            { method: "POST", body: JSON.stringify(dataSend) }) //send to Api
            .then(res => res.json()).then((data) => {
              //See response
            
               SaveProfilePic(data,officeLocationId,value)
              props.showAlert("Documents Uploaded Successfully","success")
      
            }).catch(err => console.log(err)) // Or Error in console
        }
      }

      const SaveProfilePic = (data,officeLocationId,value)=>{
        if(officeLocationId){
        
                let apiURL=process.env.REACT_APP_API_URL + "/recruiterofficelocations/saveRecruiterOfficeLogoUrl/" + officeLocationId;
                let apiParams = {
                    method:"POST",
                    headers:{
                      officelogourl:data.url,
                      value:value,
                      authtoken: localStorage.getItem("loggedintoken")
                    }
              }
              fetch(apiURL, apiParams)
              .then((res)=> (res.status===200 ? res.json() : res.text()))
              .then((repos)=> {
                  if (repos.data) {
                   
                
                  }
                })
                .catch(e => console.log(e)) 
          } 
              }
        

  const UpdateOfficeLocations = (id) => {

    let apiURL = process.env.REACT_APP_API_URL + "/recruiterofficelocations/updaterecruiterOfficeLocations/" + id;
    let apiParams = {
      method: "POST",
      headers: {
        state: state,
        city: city,
        company:company,
        office:office,
        latitude: latitude,
        longitude: longitude,
        mapurl:mapUrl,
        active: active,
        authtoken: localStorage.getItem("loggedintoken")
      },
      body:profilePic,
    };
    fetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
            handleClose()
          setIsLoading(false);
         
          profilePic && UploadImageToDrive(repos.data._id,"logo",profilePic)
          aldocument && UploadImageToDrive(repos.data._id,"AuthorisationLetter",aldocument)
          props.showAlert("Updated Successfully!!!", "success");
        
        }
      })
      .catch((err) => props.showAlert("" + err, "error"));
  };

  const addOfficeLocations = () => {
    let apiURL = process.env.REACT_APP_API_URL + "/recruiterofficelocations/addrecruiterofficeLocations";
    let apiParams = {
      method: "POST",
      headers: {
        state: state,
        city: city,
        company:company,
        office:office,
        latitude: latitude,
        longitude: longitude,
        mapurl:mapUrl,
        recruiterid:user._id,
        recruitername:user.name,
        active: active,
        authtoken: localStorage.getItem("loggedintoken")
      },
      body:profilePic,
    };
    fetch(apiURL, apiParams)
      .then((res) => (res.status === 200 ? res.json() : res.text()))
      .then((repos) => {
        if (repos.data) {
            handleClose()
          setIsLoading(false);
         
          profilePic && UploadImageToDrive(repos.data._id,"logo",profilePic)
          aldocument && UploadImageToDrive(repos.data._id,"AuthorisationLetter",aldocument)
          props.showAlert("Office Locations Added Successfully", "success");
        
        }
        else{
               props.showAlert(repos.message||repos||"Error","error");
        }
      })
      .catch((err) => props.showAlert("" + err, "error"));
  };


  const alDocUpload = async (e) => {
    if (e.target.files[0].size > 71680) {
      //alert("Please choose a file with size below 70kb!");
      props.showAlert("Please choose a file with size below 70kb!","error")
      return;
    }
    // handleCRDFileSelect(e.target.files[0]);
    alert("File Selected is "+e.target.files[0].name)
    setAlDName(e.target.files[0].name)
    setALdocument(e.target.files[0]);
   
  };

  


  return (
    <div>
       <Modal
          open={openOLPopUp}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
<div id="office_location">
	<img id="bdr_design_pfp_1" src="office_loc_bg_all.png" srcset="office_loc_bg_all.png 1x" alt="reload"/>
		
	<div id="bg_design_grp">
		<svg class="bg_design_2" viewBox="1805.416 80.996 349.05 146.684">
			<path id="bg_design_2" d="M 2135.64599609375 81 C 2116.695068359375 81.37442016601562 1820.19140625 81 1820.19140625 81 C 1820.19140625 81 1812.0615234375 81.42062377929688 1807.897705078125 90.31346130371094 C 1804.803955078125 96.919189453125 1805.478271484375 111.1990280151367 1805.478271484375 118.5688171386719 C 1805.478271484375 135.2425537109375 2154.46630859375 227.6797332763672 2154.46630859375 227.6797332763672 L 2154.46630859375 104.5640258789062 C 2154.46630859375 104.5640258789062 2154.596923828125 80.62557983398438 2135.64599609375 81 Z">
			</path>
		</svg>
		<svg class="bg_design_1" viewBox="1805.416 80.996 349.05 146.684">
			<path id="bg_design_1" d="M 1824.236572265625 81 C 1843.1875 81.37442016601562 2139.69091796875 81 2139.69091796875 81 C 2139.69091796875 81 2147.82080078125 81.42062377929688 2151.98486328125 90.31346130371094 C 2155.078369140625 96.919189453125 2154.404052734375 111.1990280151367 2154.404052734375 118.5688171386719 C 2154.404052734375 135.2425537109375 1805.416259765625 227.6797332763672 1805.416259765625 227.6797332763672 L 1805.416259765625 104.5640258789062 C 1805.416259765625 104.5640258789062 1805.28564453125 80.62557983398438 1824.236572265625 81 Z">
			</path>
		</svg>
	</div>
	<svg class="pfp_behind_circle">
		<ellipse id="pfp_behind_circle" rx="50" ry="50" cx="50" cy="50">
		</ellipse>
	</svg>
    <label for="image">
                        <input id="image" type="file" name="image"  hidden accept="image/*" onChange={(e) => handleImageUpload(e)}/>
                      <img id="profile_pfp_img" width="100" height="100" src={img?img:"profile_pfp_img_ol.png"} alt="Reload?" style={{border:"1px solid black",objectFit:"contain"}}/>
                      </label>
	{/* <img id="profile_pfp_img" src="profile_pfp_img_ol.png" srcset="profile_pfp_img_ol.png 1x" alt="reload"/> */}
		
	<div id="active_lbl">
		<span>Active</span>
	</div>
    {/* <svg class="active_chkbx">
		<rect id="active_chkbx" rx="0" ry="0" x="0" y="0" width="38" height="20">
		</rect>
	</svg> */}
    <div className="active_chkbx">
    <Switch
      id="active_chkbx"
      checked={active}
      onChange={(e)=>setActive(e.target.checked)}
      inputProps={{ 'aria-label': 'controlled' }}
    />
    </div>
    


	<div id="state_grp_prof">
		<div id="state_lbl_pfp">
			<span>State</span>
		</div>
		<select type="name" class="state_input_pfp" value={state}
                              
                                onChange={(e) => {
                                  setState(e.target.value);
                                }}
                              >
                              <option></option>
                                {States &&
                                  States.map((state) => (
                                    <option value={state.name}>
                                      {state.name}
                                    </option>
                                  ))}
		  </select>
	</div>
	<div id="city_grp_prof">
		<div id="city_lbl_pfp">
			<span>City</span>
		</div>
		<input class="city_input_pfp"  value={city || ""}
                              onChange={(e) => {
                                setCity(e.target.value);
                              }}/>
		
	</div>
	<div id="company_grp">
		<div id="company_lbl_pfp">
			<span>Company</span>
		</div>
		<input class="company_input_pfp"   value={company || ""}
                              onChange={(e) => {
                                setCompany(e.target.value);
                              }}/>
			{/* <rect id="company_input_pfp" rx="0" ry="0" x="0" y="0" width="219" height="40">
			</rect>
		</input> */}
	</div>
	<div id="office_grp">
		<div id="office_lbl_pfp">
			<span>Office</span>
		</div>
		<input  class="office_input_pfp"  value={office || ""}
                              onChange={(e) => {
                                setOffice(e.target.value);
                              }}/>
			{/* <rect id="office_input_pfp" rx="0" ry="0" x="0" y="0" width="219" height="40">
			</rect>
		</input> */}
	</div>
	<div id="latitiude_grp">
		<div id="latitude_lbl">
			<span>Latitude</span>
		</div>
		<input  class="latitude_input"  value={latitude}
                              onChange={(e) => {
                                setLatitude(e.target.value);
                              }}/>
			{/* <rect id="latitude_input" rx="0" ry="0" x="0" y="0" width="219" height="40">
			</rect>
		</input> */}
	</div>
	<div id="long_grp">
		<div id="long_lbl">
			<span>Longitude</span>
	</div>
		<input  class="long_input"  value={longitude || ""}
                              onChange={(e) => {
                                setLongitude(e.target.value);
                              }}/>
			{/* <rect id="long_input" rx="0" ry="0" x="0" y="0" width="219" height="40">
			</rect>
		</input> */}
	</div>
	<div id="location_grp">
		<div id="location_lbl">
			<span>Maps Location URL</span>
		</div>
		<input class="location_input"  value={mapUrl || ""}
                              onChange={(e) => {
                                setMapUrl(e.target.value);
                              }}/> 
			{/* <rect id="location_input" rx="0" ry="0" x="0" y="0" width="468" height="40">
			</rect>
		</input> */}
	</div>
    
    <div id="location_grp_bn">
		<div id="location_lbl_bo">
			<span>Authorisation Letter</span>
		</div>
	</div>
      {/*Authrisation Upload and Download*/}
      <label for="al">
                        <input id="al" type="file" name="image"  hidden accept="image/*" onChange={(e) => alDocUpload(e)}/>
                      <img id="upload1_img_rec_popup" width="100" height="100" src="upload1_img_rec.png" title={alDName?alDName:"Upload Image!!"}  alt="Reload?" />
     </label>
	{/* <img title="Upload" id="upload1_img_rec" src="upload1_img_rec.png" srcset="upload1_img_rec.png 1x" alt="reload" /> */}
   
	{id.length > 0 && documentUrl && documentUrl!=="" ?<img title="Download" id="download1_img_rec" src="download1_img_rec.png" srcset="download1_img_rec.png 1x" alt="reload" onClick={(e)=>document.getElementById('candidateResumeDownload').click()}/>:""}

    {documentUrl && documentUrl!=="" ?  <a  id="candidateResumeDownload"  style={{display:"none"}} name="Document" href={documentUrl}  target="_blank" ></a>:""}


    <button id="change_pass_btn_grp" onClick={() =>
                          id.length > 0
                            ? UpdateOfficeLocations(id)
                            : addOfficeLocations()
                        }>
		<svg class="passs_bdr_btn">
			<rect id="passs_bdr_btn" rx="8" ry="8" x="0" y="0" width="141" height="52">
			</rect>
		</svg>
		<div id="Change_Password_lbl">
			<span>{id.length > 0 ? "EDIT" : "ADD"}</span>
		</div>
	</button>


	<img id="close_off_loc_" src="close_office_loc.png" srcset="close_office_loc.png 1x" alt="reload" onClick={()=>handleClose()}/>
		
</div>
        </Modal>
    </div>
  )
}

export default AddOfficeLocationPopUpUI
